// Второй директор (deus_vtoroy_direktor, epic) — passive aura.
// Все союзные юниты (включая самого) получают +N/N/N где N = floor(влияние / 3).
// 0-2 = 0; 3-5 = 1; 6-8 = 2; 9-10 = 3.
// Аура динамическая: пересчёт мгновенно при изменении Влияния, размещении, смерти.
//
// Аура хранится в card.directorAuraApplied = {atk, armor, hp}. При пересчёте:
//   targetBonus = N * (число живых Вторых директоров на стороне)
//   Δ = targetBonus - applied
//   current.atk/armor/hp += Δ; applied = targetBonus.
//
// Пересчёт может уронить HP юнита ниже 0 — тогда его убираем с поля и логируем.

export const CARD_ID = 'deus_vtoroy_direktor';

function bonusPerDirector(influence) {
  return Math.floor(Math.max(0, Math.min(10, influence)) / 3);
}

export function recomputeDirectorAura(state) {
  for (let idx = 0; idx < 2; idx++) {
    const p = state.players[idx];
    if (!p) continue;
    if (p.hero.faction !== 'deus') continue;
    const directors = p.unitsOnField().filter(u => u.id === CARD_ID);
    const perDir = bonusPerDirector(p.influence);
    const N = directors.length * perDir;
    const allies = p.unitsOnField();          // снимок до возможной смерти
    const dead = [];
    for (const u of allies) {
      const applied = u.directorAuraApplied || { atk: 0, armor: 0, hp: 0 };
      const dAtk = N - applied.atk;
      const dArm = N - applied.armor;
      const dHp  = N - applied.hp;
      if (dAtk === 0 && dArm === 0 && dHp === 0) continue;
      u.current.atk = Math.max(0, u.current.atk + dAtk);
      u.current.armor = Math.max(0, u.current.armor + dArm);
      u.current.hp = u.current.hp + dHp;
      u.directorAuraApplied = { atk: N, armor: N, hp: N };
      if (u.current.hp <= 0) dead.push(u);
    }
    for (const u of dead) {
      state.log.add(`✗ ${u.name_ru} [${p.name}] не выдержал снятие ауры — погибает`);
      p.removeFromField(u);
    }
  }
}
